import { html, PropertyValues } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseWidget } from "./base-widget";

// Quick link widget implementation.  The contents of quick link is determined right when the landing page loads.  
// There is no need to load the contents from a URL.  So this widget will have a slot, and the landing page will supply 
// the required elements in the slot.  The same slot can be used by multiple elements, so add all the links to this slot
export class QuickLinkWidget extends BaseWidget {
    // Overriding content part of the widget.render().  We just need a slot here!
    getContentLoaderSlot() {
        return html`
            <div class="widget-content-class">
                <slot name="widgetcontent"></slot>
            </div>
        `;
    }
    // Widget is loaded, make sure state is maintained
    firstUpdated(changedProperties: PropertyValues) {
        this.showOrHideForState();
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'quicklink-widget': QuickLinkWidget;
    }
}

